import React, { useContext, useEffect } from 'react';
import { PlugFill } from 'react-bootstrap-icons';
import { AuthContext } from '../../contexts/AuthContext';
import { TradeStationOnboardingPromoStrip } from '../shared/TradeStationReferralPromoBar';
import BrokerConnectList from './BrokerConnectList';
import BrokerStepHeading from './BrokerStepHeading';
import { BROKER_CONNECT_ACCENT } from '../../constants/brokerConnectColors';

/**
 * Connect-broker body (heading + promo + searchable list).
 * Used inside ConnectBrokerModal and the post-onboarding orientation shell —
 * keep presentation here so both entry points stay in sync.
 */
export default function ConnectBrokerContent({ onBusyChange, className }) {
  const { user, refreshUserSettings } = useContext(AuthContext);

  useEffect(() => {
    if (!user?.token) return;
    refreshUserSettings?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refresh once on mount
  }, [user?.token]);

  return (
    <div className={className || 'connect-broker-content'}>
      <div className="connect-broker-modal-header">
        <BrokerStepHeading
          icon={<PlugFill size={20} style={{ color: BROKER_CONNECT_ACCENT }} aria-hidden />}
          heading="Connect your broker"
          subtitle="Link a broker to start trading with your rules in place."
        />
        <div style={{ marginBottom: 20 }}>
          <TradeStationOnboardingPromoStrip />
        </div>
      </div>
      <BrokerConnectList onBusyChange={onBusyChange} />
    </div>
  );
}
